// `useExecuteOrionDomainQuery` needs a summit clientId to resolve the Orion
// API token. Variable shapes vary: stored pipelineCodes get wrapped under
// `filters` by `usePipelineQuery`; inline pipelines pass through as-is.
function toFiniteId (v) {
  if (typeof v === 'number' && Number.isFinite(v)) return v
  if (typeof v === 'string' && v.trim() !== '') {
    const n = Number(v)
    if (Number.isFinite(n)) return n
  }
  return null
}

export function extractClientIdFromVariables (variables) {
  if (!variables) return null
  const candidates = [
    variables.filters?.levelTypeId === 201 ? variables.filters?.levelIds?.[0] : null,
    variables.levelTypeId === 201 ? variables.levelIds?.[0] : null,
    variables.filters?.clientId,
    variables.clientId
  ]
  for (const c of candidates) {
    const id = toFiniteId(c)
    if (id !== null) return id
  }
  return null
}
